import { getClient } from "../utils/apiClient";
import { getSdk } from "../generated/graphql";

const sdk = () => getSdk(getClient());

export type PartnerActivity = {
  id: number;
  user_id: number;
  activity_type: string;
  actor: string;
  title: string;
  message?: string | null;
  link?: string | null;
  metadata?: Record<string, unknown> | null;
  is_read: boolean;
  requires_response: boolean;
  response_status?: string | null;
  response_note?: string | null;
  responded_at?: string | null;
  created_at: string;
};

export async function fetchMyActivities(
  limit?: number,
  unreadOnly?: boolean,
  activityType?: string,
  since?: string,
  offset?: number
): Promise<PartnerActivity[]> {
  const { getMyActivities } = await sdk().GetMyActivities({
    limit,
    offset,
    unread_only: unreadOnly,
    activity_type: activityType,
    since,
  });
  return (getMyActivities ?? []).filter(
    Boolean
  ) as unknown as PartnerActivity[];
}

export async function fetchUnreadActivityCount(
  excludeActor?: string
): Promise<number> {
  const { getUnreadActivityCount } = await sdk().GetUnreadActivityCount({
    exclude_actor: excludeActor,
  });
  return (getUnreadActivityCount ?? 0) as number;
}

export async function fetchPendingResponses(): Promise<PartnerActivity[]> {
  const { getPendingResponses } = await sdk().GetPendingResponses();
  return (getPendingResponses ?? []).filter(
    Boolean
  ) as unknown as PartnerActivity[];
}

export async function createActivity(activity: {
  activity_type: string;
  actor: string;
  title: string;
  message?: string;
  link?: string;
  metadata?: Record<string, unknown>;
  requires_response?: boolean;
}): Promise<{ id: number; created_at: string }> {
  const { createActivity: result } = await sdk().CreateActivity(activity);
  return result;
}

export async function markActivitiesRead(
  activityIds?: number[],
  markAll?: boolean
): Promise<boolean> {
  const { markActivitiesRead: result } = await sdk().MarkActivitiesRead({
    activity_ids: activityIds,
    mark_all: markAll,
  });
  return result as boolean;
}

export async function respondToActivity(
  activityId: number,
  responseStatus: string,
  responseNote?: string
): Promise<PartnerActivity> {
  const { respondToActivity: result } = await sdk().RespondToActivity({
    activity_id: activityId,
    response_status: responseStatus,
    response_note: responseNote,
  });
  return result;
}
